import React from 'react';
import Select from 'react-select';
import AppFilterInput from '../../appFilterDashlet/appFilterInput';
import { postEntity } from 'src/utils/entityApi';

import linksGraphics from 'src/data/dashlet/links-modules-graphics';
import data_modules from 'src/data/dashlet/dashlet-modules';
import withAuth from 'src/hoc/withAuth';

const apiDashboard = '/api/dashboard/';

const oriState = {
  stepView: 1,
  title: undefined,
  moduleSelected: '',
  statisticSelected: undefined,
  chartSelected: '',
  rowFilters: {},
  metadata: undefined,
  userDashboards: undefined,
  dashboardSelected: undefined,
  layout: 'semi-row',
  isFromExisting: false,
};

const stepMax = 2;

class DashletStatisticForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = oriState;

    this.handleInputSelectChange = this.handleInputSelectChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.addRowFilter = this.addRowFilter.bind(this);
    this.removeRowFilter = this.removeRowFilter.bind(this);
    this.decrementStep = this.decrementStep.bind(this);
    this.incrementStep = this.incrementStep.bind(this);
    this.refreshFields = this.refreshFields.bind(this);
    this.updateListFilters = this.updateListFilters.bind(this);
  }

  handleInputSelectChange(val, typeSelect) {
    this.setState({
      [typeSelect]: val,
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleClickIcon(event) {
    this.setState({
      chartSelected: event,
    });
  }

  addRowFilter(filter) {
    let newInput = this.state.rowFilters;
    newInput[`filter-${Object.keys(newInput).length}`] = filter;
    this.setState({
      rowFilters: newInput,
    });
  }

  removeRowFilter() {
    let newInputs = this.state.rowFilters;
    delete newInputs[`filter-${Object.keys(newInputs).length - 1}`];
    this.setState({
      rowFilters: newInputs,
    });
  }

  refreshFields(module) {
    this.prepareColumsForFilters(module);
  }

  /*
        Some columns can't be filtered
    */
  prepareColumsForFilters(module) {
    if (module) {
      let myColumnsFilters = [];
      for (let i = 0; i < module.columns.length; i++) {
        if (!module.columns[i].noFilter) {
          myColumnsFilters.push(module.columns[i]);
        }
      }
      this.setState({
        columnsForFilters: myColumnsFilters,
      });
    }
  }

  getDashboards() {
    let queryURL = apiDashboard;
    let graphQL = '{ dashboards{ id, title } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            userDashboards: data['data']['dashboards'],
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch dashboards: \n' + error);
        }.bind(this)
      );
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  componentDidMount() {
    this.props.onRef(this);

    this.getDashboards();
    /*
            If the modal is open from an existing dashlet in order to update it
        */
    if (this.props.fillFromExisting) {
      let existingDashlet = this.props.fillFromExisting();
      if (existingDashlet && existingDashlet.type !== 'dashlet-list') {
        this.setState({
          title: existingDashlet.title,
          rowFilters:
            existingDashlet.metadata.filters.length > 0 || Object.keys(existingDashlet.metadata.filters).length > 0
              ? existingDashlet.metadata.filters
              : {},
          moduleSelected: existingDashlet.metadata.module,
          layout: existingDashlet.metadata.layout,
          statisticSelected: existingDashlet.metadata.statisticSelected,
          isFromExisting: true,
          chartSelected: existingDashlet.type.substring(8),
        });

        this.refreshFields(existingDashlet.metadata.module);
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // after input update
    if (prevState.moduleSelected !== this.state.moduleSelected) {
      this.refreshFields(this.state.moduleSelected);
    }

    //Here we want to find the dashboard of the existing dashlet
    if (this.state.isFromExisting && prevState.userDashboards !== this.state.userDashboards) {
      let existingDashlet = this.props.fillFromExisting();
      for (let i = 0; i < this.state.userDashboards.length; i++) {
        if (existingDashlet.dashboard.id === this.state.userDashboards[i].id) {
          this.setState({
            dashboardSelected: this.state.userDashboards[i],
          });
        }
      }
    }

    return true;
  }

  incrementStep() {
    let newStep = this.state.stepView;
    newStep += 1;
    this.setState({
      stepView: newStep,
    });
  }

  decrementStep() {
    let newStep = this.state.stepView;
    newStep -= 1;
    this.setState({
      stepView: newStep,
    });
  }

  reset() {
    this.state = oriState; // After closing the modal, the rowFilters are still present
    for (let i = 0; i <= Object.keys(this.state.rowFilters).length; i++) {
      this.removeRowFilter();
    }
  }

  checkFormIsValid() {
    let noFilterProblem = true;
    for (let [key, filter] of Object.entries(this.state.rowFilters)) {
      if (filter) {
        if (
          (filter.columnSelected && !filter.operatorSelected) ||
          (filter.operatorSelected && filter.operatorSelected.nbParam > 0 && !filter.param1) ||
          (filter.operatorSelected && filter.operatorSelected.nbParam > 1 && !filter.param2)
        ) {
          noFilterProblem = false;
        }
      }
    }

    return (
      this.state.moduleSelected &&
      this.state.title &&
      this.state.title.trim() !== '' &&
      noFilterProblem &&
      this.state.statisticSelected &&
      this.state.chartSelected
    );
  }

  handleSubmit() {
    if (this.props.onPostResult) {
      if (this.checkFormIsValid()) {
        let json = {
          dashlet: {
            title: this.state.title,
            type: 'dashlet-' + this.state.chartSelected,
            dashboardId: this.state.dashboardSelected.id,
            metadata: {
              module: this.state.moduleSelected,
              filters: this.cleanRowFilter(this.state.rowFilters),
              statisticSelected: this.state.statisticSelected,
              layout: this.state.layout,
            },
          },
        };

        if (this.state.isFromExisting) {
          let existingDashlet = this.props.fillFromExisting();
          json.dashlet.id = existingDashlet.id;
          this.props.onPostResult('update-dashlet', postEntity(this.props.authFetch, 'dashlet', json));
        } else {
          this.props.onPostResult('dashlet', postEntity(this.props.authFetch, 'dashlet', json));
        }
      } else {
        this.props.openToast(false, 'Certains champs obligatoires sont vides');
      }
    }
  }

  removeFilter = (key) => {
    let newInputs = this.state.rowFilters;
    newInputs[key] = undefined;
    this.setState({
      rowFilters: newInputs,
    });
  };

  cleanRowFilter = (rowFilter) => {
    const newRowFilter = {};
    let deleteCount = 0;

    Object.keys(rowFilter || {}).forEach((key, index) => {
      if (rowFilter[key] && rowFilter[key].columnSelected) {
        newRowFilter[`filter-${index - deleteCount}`] = rowFilter[key];
      } else {
        deleteCount++;
      }
    });

    return newRowFilter;
  };

  updateListFilters(key, columnSelected, operatorSelected, param1, param2) {
    // Called when a new row is set

    // 1) Create the object
    let object = {
      columnSelected: columnSelected,
      operatorSelected: operatorSelected,
      param1: param1,
      param2: param2,
    };

    // 2) Update the list
    let list = this.state.rowFilters;
    list[key] = object;
    this.setState({
      rowFilters: list,
    });
  }

  render() {
    if (this.props.isStatsFormSelected === false) return null;

    return (
      <div>
        {this.state.stepView === 1 && (
          <div className=''>
            <strong>Paramétrage</strong>
            <div className='form-group'>
              <label>Titre</label>
              <input
                name='title'
                value={this.state.title}
                onChange={this.handleInputChange}
                type='text'
                className='form-control'
                placeholder='Mon Dashlet'
              />
            </div>
            <div className='form-group'>
              <label>Dashboard</label>
              <Select
                multi={false}
                className='inputModalSelect'
                name='dashboardSelected'
                value={this.state.dashboardSelected}
                labelKey={'title'}
                valueKey={'title'}
                options={this.state.userDashboards}
                onChange={(val) => this.handleInputSelectChange(val, 'dashboardSelected')}
                noResultsText={'Aucun résultat'}
                placeholder={'Nom'}
                clearValueText={'Supprimer'}
                disabled={!!this.state.isFromExisting}
              />
            </div>
            <div className='form-group'>
              <label>Module</label>
              <Select
                multi={false}
                className='inputModalSelect'
                name='moduleSelected'
                value={this.state.moduleSelected}
                labelKey={'name'}
                valueKey={'name'}
                options={data_modules}
                onChange={(val) => this.handleInputSelectChange(val, 'moduleSelected')}
                noResultsText={'Aucun résultat'}
                placeholder={'Nom'}
                clearValueText={'Supprimer'}
              />
            </div>
            <div className='form-group'>
              <label>Donnée statistique</label>
              <Select
                multi={false}
                className='inputModalSelect'
                name='statisticSelected'
                value={this.state.statisticSelected}
                labelKey={'name'}
                valueKey={'name'}
                options={this.state.moduleSelected ? linksGraphics[this.state.moduleSelected.name]['statistics'] : []}
                onChange={(val) => this.handleInputSelectChange(val, 'statisticSelected')}
                noResultsText={'Aucun résultat'}
                placeholder={'Nom'}
                clearValueText={'Supprimer'}
              />
            </div>
            <div className='form-group'>
              <label>Disposition</label>
              <div className='custom-control custom-radio'>
                <input
                  type='radio'
                  className='form-check-input'
                  name='layout'
                  value='complete-row'
                  onChange={this.handleInputChange}
                  checked={this.state.layout === 'complete-row'}
                />
                <label className='custom-control-label'>Ligne entière</label>
              </div>
              <div className='custom-control custom-radio'>
                <input
                  type='radio'
                  className='form-check-input'
                  name='layout'
                  value='semi-row'
                  onChange={this.handleInputChange}
                  checked={this.state.layout === 'semi-row'}
                />
                <label className='custom-control-label'>Demi ligne</label>
              </div>
            </div>
            <div className='form-group'>
              <label>Chosir le type de graphe</label>
              <div className='chart-selector'>
                <input
                  id='pie'
                  type='radio'
                  className='form-check-input'
                  checked={this.state.chartSelected === 'pie'}
                />
                <label htmlFor='pie' className='drinkcard-cc pie' onClick={() => this.handleClickIcon('pie')} />

                <input
                  id='bar'
                  type='radio'
                  className='form-check-input'
                  checked={this.state.chartSelected === 'bar'}
                />
                <label htmlFor='bar' className='drinkcard-cc bar' onClick={() => this.handleClickIcon('bar')} />

                <input
                  id='horizontal-bar'
                  type='radio'
                  className='form-check-input'
                  checked={this.state.chartSelected === 'horizontal-bar'}
                />
                <label
                  htmlFor='horizontal-bar'
                  className='drinkcard-cc horizontal-bar'
                  onClick={() => this.handleClickIcon('horizontal-bar')}
                />

                {/*
                                <input id="lines" type="radio" className="form-check-input"  checked={this.state.chartSelected === "lines"}/>
                                <label for="lines"  className="drinkcard-cc lines" onClick={()=>this.handleClickIcon("lines")}></label>

                                <input id="funnel" type="radio" className="form-check-input" checked={this.state.chartSelected === "funnel"}/>
                                <label for="funnel" className="drinkcard-cc funnel" onClick={()=>this.handleClickIcon("funnel")}></label>

                                <input id="speedometer" type="radio" className="form-check-input" checked={this.state.chartSelected === "speedometer"}/>
                                <label for="speedometer" className="drinkcard-cc speedometer" onClick={()=>this.handleClickIcon("speedometer")}></label>*/}
              </div>
            </div>
          </div>
        )}

        {this.state.stepView === 2 && (
          <div className='dashlet-filters'>
            <strong>Filtres</strong>
            {/*                        <div className="form-group">
                                <label>Logique combinatoire</label>
                                <Select
                                    multi={false}
                                    className="inputModalSelect"
                                    name="combinatorialLogic" value={this.state.combinatorialLogic}
                                    labelKey={"label"}
                                    valueKey={"label"}
                                    options={combinatorialLogics}
                                    onChange={(val)=> this.handleInputSelectChange(val, "orderBy")}
                                    noResultsText={"Aucun résultat"} clearValueText={"Supprimer"}
                                />
                            </div>*/}
            <button onClick={() => this.addRowFilter()} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus' />
            </button>
            <button onClick={() => this.removeRowFilter()} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-minus' />
            </button>
            <div>
              {Object.entries(this.state.rowFilters).map(([inputKey, value]) => (
                <AppFilterInput
                  save={value}
                  id={inputKey}
                  key={inputKey}
                  removeFilter={this.removeFilter}
                  columnsOfModule={this.state.columnsForFilters}
                  updateListFilters={this.updateListFilters}
                />
              ))}
            </div>
          </div>
        )}

        {this.state.stepView < stepMax && (
          <button onClick={this.incrementStep} type='button' className={'btn btn-primary button-dashlet-form'}>
            <span className='icon icon-chevron-right'>Suivant</span>
          </button>
        )}
        {this.state.stepView > 1 && (
          <button onClick={this.decrementStep} type='button' className={'btn btn-primary button-dashlet-form'}>
            <span className='icon icon-chevron-left'>Précédent</span>
          </button>
        )}
      </div>
    );
  }
}

export default withAuth(DashletStatisticForm);
